<template>
  <div>
    <div class="overlay"></div>
    <div class="modal_fixed">
      <div class="modal_box modal_cont new_game new_game_2" id="modal_new_game2">
<!--        <img :src="getTranslations.logo_for_game_modal_projects || 'static/images/Swipo_logo_01.png'"  class="game_modal_logo">-->
        <div class="new_game_title">{{ getTranslations.home_pre_game_modal2_title1 }}<br> {{ getTranslations.home_pre_game_modal2_title2 }}</div>
        <div class="d_row" v-if="swipoGameThemes !== 'SEASONAL'">
          <div :class="['cat_box', gameType.toLowerCase()]">{{ translateCategory(gameType.toLowerCase()) }}</div>
        </div>
        <div class="d_row" v-else>
          <div :class="['cat_box', ]" :style="{ cursor: 'pointer',  backgroundColor: colors }">{{ gameName }}</div>
        </div>
        <div class="new_game_txt">
          {{ getTranslations.home_pre_game_modal2_txt1 }} <span>{{ getTranslations.home_pre_game_modal2_txt2 }}</span> {{ getTranslations.home_pre_game_modal2_txt3 }} <br>
          {{ getTranslations.home_pre_game_modal2_txt4 }}
        </div>
        <div class="new_game_txt">
          <span>{{ getTranslations.home_pre_game_modal2_swipe }}</span> <br>
          {{ getTranslations.home_pre_game_modal2_correct }}
        </div>
        <div class="new_game_txt">
          {{ getTranslations.home_pre_game_modal2_good_luck }}
        </div>
        <img src="/static/images/big_prizes.png" class="big_prizes">

        <div class="d_row end_row">
          <div class="unlocked_games"><span>{{ userDetails.availableGames }}</span> {{ getTranslations.home_pre_game_modal2_unlocked_games }}</div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import NewGameMixin from '@/common/mixins/home';

export default {
  name: 'category-choosed-modal',
  mixins: [NewGameMixin],
  mounted() {
    setTimeout(() => {
      this.playGameMethod();
    }, this.swipoTimeForPreGameModals);
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
      'storeModalForStore',
    ]),
    translateCategory(category) {
      return this.getTranslations[`game_category_${category}`];
    },
    playGameMethod() {
      this.playGame(this.gameType);
    },
  },
  computed: {
    ...mapState('common', [
      'modalForHomePage',
      'userDetails',
      'swipoGameThemes',
      'swipoTimeForPreGameModals',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('game', [
      'gameType',
      'gameName',
      'colors',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/pregame/CategoryChoosed.vue